import Vue from 'vue';
import Router from 'vue-router';
import HelloWorld from '@/components/HelloWorld';
import ourfosters from '@/components/our-fosters';
import aboutbeagles from '@/components/about-beagles';
import Adopt from '@/components/Adopt';
import Pages from '@/components/Pages';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld,
    },
    {
      path: '/our-beagles',
      name: 'Our Beagles',
      component: ourfosters,
    },
    {
      path: '/about-beagles',
      name: 'About Beagles',
      component: aboutbeagles,
    },
    {
      path: '/adopt',
      name: 'Adopt',
      component: Adopt,
    },
    {
      path: '/pages/:slug',
      component: Pages,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js